<template>
	<div class="layer-project" data-project-name="lgchem">
		<!-- Project Name -->
		<div class="layer-project-detail">
			<!-- Page Contents -->
			<section class="project-visual">
				<div>
					<h1 class="project-tit"><span class="award13"></span>LG Chem</h1>
					<a href="http://www.lgchem.com" class="link" target="_blank"
						>www.lgchem.com</a
					>
				</div>
			</section>
			<!-- Details [s] -->
			<section class="project-overview">
				<div class="inner-section">
					<h2 class="project-overview-tit">Overview</h2>
					<p class="project-overview-txt">
						대한민국 대표 화학기업인 LG화학의 기업홍보 및 제품소개 페이지를
						구축했습니다. <br />LG화학의 아이덴티티 강화와 사용자 중심의
						정보설계에 주안점을 두고 작업했습니다. <br />브랜드 강화를 위한 사진
						촬영 및 콘텐츠 강화를 통해 사용자에게 LG화학의 브랜드 가치를
						전달하고자 하였습니다.
					</p>
					<div class="project-overview-diagram">
						<ul class="diagram01">
							<li class="item01">Basic Materials &amp; Chemicals</li>
							<li class="item02">Energy Solution</li>
						</ul>
						<ul class="diagram02">
							<li class="item01">IT &amp; Electronics Material</li>
							<li class="item02">Advanced Materials</li>
						</ul>
						<ul class="diagram03">
							<li class="item01">Life Sciences</li>
						</ul>
					</div>
				</div>
			</section>

			<!-- Details [e] -->
			<section class="section full section01">
				<div class="inner-section">
					<div class="pc-web-wrap">
						<strong class="project-subtit">PC Web</strong>
						<p class="sub-text">
							Half &amp; Half Layout으로 구성하여 키 비주얼과 콘텐츠를 양쪽으로
							배치하여 한 눈에 이미지와 내용을 볼 수 있는 구조로 구성했습니다.
							<span
								>새로운 비주얼 콘셉트를 위해 제품촬영을 하였고, 비주얼 톤에 맞춰
								콘텐츠의 구성도 배너 형태로 디자인 하였습니다.</span
							>
							비주얼과 콘텐츠 배너에는 마우스 오버 시 인터렉션을 적용하여
							사용자의 시각적 즐거움까지 고려했습니다.
						</p>
					</div>
					<div class="img">
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/lgchem/pc-web-img@m.png"
						/>
					</div>
				</div>
			</section>

			<section class="section section02">
				<div class="inner-section">
					<div class="title">
						<strong
							>Company Leading the Chemical Industry in Korea – LG Chem</strong
						>
						<p class="text">
							LG Chem is committed to becoming a global company that realizes
							the vision of
							<span
								>“growing with customers by providing innovative materials and
								solutions”</span
							>
							and provides new values to customers.
						</p>
					</div>
					<div class="list">
						<ul>
							<li class="item01">Customer Value Creation</li>
							<li class="item02">Strong Implementation</li>
							<li class="item03">Mutual Respect</li>
						</ul>
					</div>
				</div>
			</section>

			<section class="section full section03">
				<div class="inner-section">
					<!-- Swiper -->
					<div class="pc-web-slider">
						<ul class="swiper-wrapper clfix">
							<li class="swiper-slide">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/lgchem/pc-web-img-01@m.png"
								/>
							</li>
							<li class="swiper-slide">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/lgchem/pc-web-img-02@m.png"
								/>
							</li>
							<li class="swiper-slide">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/lgchem/pc-web-img-03@m.png"
								/>
							</li>
							<li class="swiper-slide">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/lgchem/pc-web-img-04@m.png"
								/>
							</li>
							<li class="swiper-slide">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/lgchem/pc-web-img-05@m.png"
								/>
							</li>
							<li class="swiper-slide">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/lgchem/pc-web-img-06@m.png"
								/>
							</li>
						</ul>

						<!-- Add Pagination -->
						<div class="swiper-pagination"></div>
					</div>
				</div>
			</section>

			<section class="section full section04">
				<div class="inner-section">
					<strong class="project-subtit">Grid</strong>
					<div class="img">
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/lgchem/grid-img@m.png"
						/>
					</div>
				</div>
			</section>

			<section class="section full section05">
				<div class="inner-section">
					<strong class="project-subtit">Mobile Web</strong>
					<div class="img">
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/lgchem/mobile-web-img@m.png"
						/>
					</div>
				</div>
			</section>

			<section class="section section06">
				<div class="inner-section">
					<div class="font-area-wrap clfix">
						<div class="img">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/lgchem/font-lg-smart@m.png"
							/>
						</div>
						<div class="img">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/lgchem/font-aria@m.png"
							/>
						</div>
					</div>
					<div class="color-area-wrap">
						<ul class="color">
							<li class="item01"><span>#222222</span></li>
							<li class="item02"><span>#6b6b6b</span></li>
							<li class="item03"><span>#a41d37</span></li>
							<li class="item04"><span>#8e754a</span></li>
							<li class="item05"><span>#a8aaad</span></li>
							<li class="item06"><span>#eeeeee</span></li>
						</ul>
					</div>
				</div>
			</section>
			<section class="project-client">
				<strong class="a11y-hidden">LG Chem</strong>
			</section>
			<!-- Page Contents -->
		</div>

		<app-pjmove></app-pjmove>
	</div>
</template>

<script>
import Swiper from "../../static/js/swiper.min.js"; /* if use swiper.min.js */
import pjMove from "../components/pjMove.vue";
import projectCommon from "../assets/js/projectCommon.js";
export default {
	components: {
		"app-pjmove": pjMove,
	},
	mixins: [projectCommon],
	mounted: function () {
		this.projectInit();

		var $window = $(window);
		var winW = $window.outerWidth();
		var flag = true;
		var isSlider = true;
		var pcwebSwiper;

		var pcWeb = function () {
			if (isSlider) {
				isSlider = false;
				pcwebSwiper = new Swiper(".pc-web-slider", {
					spaceBetween: 15,
					pagination: {
						el: ".swiper-pagination",
						clickable: true,
					},
				});
			}
		};

		if (winW < 712) {
			pcWeb();
		} else {
			isSlider = true;
		}

		$window.on("resize", function () {
			winW = $window.outerWidth();
			if (winW < 712) {
				if (flag) {
					flag = false;
					pcWeb();
				}
			} else {
				flag = true;
				if (!isSlider) {
					isSlider = true;
					pcwebSwiper.destroy();
					$(".swiper-pagination").children().remove();
				}
			}
		});
	},
};
</script>

<style scoped>
@import "../../static/css/projects.css"; /* Common Project Detail Page */
/* Common */
.project-subtit {
	padding: 0 15px;
}
.sub-text {
	word-break: keep-all;
}
@media screen and (min-width: 712px) {
	.project-subtit {
		padding: 0 40px;
	}
}
@media screen and (min-width: 1280px) {
	.project-subtit {
		padding: 0 20px;
	}
}

/* Project Visual, Project CI */
.project-client {
	background: #e9e9e9 url(/static/img/project-detail/lgchem/ci.png) 50% / auto
		46px no-repeat;
}
@media screen and (max-width: 711px) {
	.project-visual {
		background-image: url(/static/img/project-detail/lgchem/bg-overview@m.jpg);
	}
}
@media screen and (min-width: 712px) {
	.project-visual {
		background-image: url(/static/img/project-detail/lgchem/bg-overview@t.jpg);
	}
	.project-client {
		background-size: auto 55.5px;
	}
}
@media screen and (min-width: 1280px) {
	.project-visual {
		background-image: url(/static/img/project-detail/lgchem/bg-overview@w.jpg);
	}
	.project-client {
		background-size: auto 111px;
	}
}

/* Overview */
.project-overview {
	background-color: #5a5a5a;
	color: #fff;
}
.project-overview-txt {
	margin-bottom: 30px;
}
.project-overview-diagram ul {
	position: relative;
	display: flex;
	justify-content: space-between;
}
.project-overview-diagram ul:not(.diagram03):after {
	content: "";
	position: absolute;
	top: 50%;
	left: 50%;
	width: 25px;
	height: 1px;
	background-color: #fff;
	transform: translate(-50%, -50%);
}
.project-overview-diagram .diagram03 {
	justify-content: center;
}
.project-overview-diagram li {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100px;
	height: 100px;
	padding: 15px;
	border-radius: 50%;
	text-align: center;
	background-color: #fff;
	color: #222;
}
@media screen and (max-width: 711px) {
	.project-overview-diagram ul {
		max-width: 320px;
		margin: 0 auto;
	}
	.project-overview-diagram ul + ul {
		margin-top: 30px;
	}
}
@media screen and (min-width: 712px) {
	.project-overview-diagram {
		display: flex;
		justify-content: center;
	}
	.project-overview-diagram ul + ul,
	.project-overview-diagram li + li {
		margin-left: 33px;
	}
	.project-overview-diagram ul + ul:before {
		content: "";
		position: absolute;
		top: 50%;
		left: -28.5px;
		width: 25px;
		height: 1px;
		background-color: #fff;
		transform: translateY(-50%);
	}
}
@media screen and (min-width: 1280px) {
	.project-overview .inner-section {
		padding: 25px 20px;
	}
	.project-overview-tit {
		font-size: 36px;
	}
	.project-overview-txt {
		margin-bottom: 55px;
		line-height: 1.8;
	}
	.project-overview-diagram li {
		width: 200px;
		height: 200px;
		font-size: 20px;
	}
	.project-overview-diagram ul + ul,
	.project-overview-diagram li + li {
		margin-left: 60px;
	}
	.project-overview-diagram ul:not(.diagram03):after {
		width: 40px;
		height: 2px;
	}
	.project-overview-diagram ul + ul:before {
		left: -50px;
		width: 40px;
		height: 2px;
	}
}

.layer-project-detail > section.section01 {
	padding-bottom: 0;
}
.section01 {
	position: relative;
	background-color: #fff;
	color: #fff;
}
.section01:before {
	content: "";
	position: absolute;
	top: 0;
	left: 0;
	z-index: 0;
	width: 100%;
	height: 40px;
	background-color: #a80031;
}
.section01 .inner-section {
	position: relative;
}
.pc-web-wrap {
	padding-bottom: 45px;
	background-color: #a80031;
}
.section01 .sub-text {
	padding: 0 15px;
}
.section01 .img {
	position: relative;
}
.section01 .img:before {
	content: "";
	position: absolute;
	top: 0;
	left: 0;
	z-index: 0;
	width: 100%;
	height: calc(100vw * (240 / 320));
	background-color: #a80031;
}
.section01 .img img {
	position: relative;
}
@media screen and (max-width: 711px) {
	.section01 .img img {
		width: 100%;
		max-width: none;
	}
	.section01 .sub-text span {
		display: block;
	}
}
@media screen and (min-width: 712px) {
	/* .section01:before{height:454px} */
	.section01 .sub-text {
		padding: 0 40px;
	}
	.section01 .img:before {
		height: calc(100vw * (227 / 712));
	}
}
@media screen and (min-width: 1280px) {
	.section.full.section01 .inner-section {
		max-width: 1280px;
	}
	.section01:before {
		height: 794px;
	}
	.section01 .inner-section {
		padding-top: 50px;
	}
	.pc-web-wrap {
		padding-bottom: 90px;
	}
	.section01 .sub-text {
		padding: 0 20px;
	}
	.section01 .sub-text span {
		display: block;
	}
	.section01 .img {
		padding-right: 20px;
	}
	.section01 .img:before {
		content: none;
	}
}

.section02 .title {
	margin-bottom: 34px;
}
.section02 .title strong {
	display: block;
	margin-bottom: 10px;
	font-size: 2rem;
	line-height: 1.2;
	font-weight: 500;
	letter-spacing: -0.05em;
}
.section02 .text {
	font-weight: 500;
	color: #666;
}
.section02 .list li {
	position: relative;
	font-weight: 500;
}
.section02 .list li:before {
	content: "";
	position: absolute;
	top: 0;
	left: 0;
	width: 62.5px;
	height: 66.5px;
	background: url(/static/img/project-detail/lgchem/lgchem-icon01.png) no-repeat;
	background-size: 100% auto;
}
.section02 .list .item02:before {
	background-image: url(/static/img/project-detail/lgchem/lgchem-icon02.png);
}
.section02 .list .item03:before {
	background-image: url(/static/img/project-detail/lgchem/lgchem-icon03.png);
}
@media screen and (max-width: 711px) {
	.section02 .list li {
		height: 66.5px;
		padding-left: 77px;
		line-height: 66.5px;
	}
	.section02 .list li + li {
		margin-top: 20px;
	}
}
@media screen and (min-width: 712px) {
	.section02 {
		text-align: center;
	}
	.section02 .inner-section {
		padding-bottom: 10px;
	}
	.section02 .title strong {
		margin-bottom: 15px;
		letter-spacing: -0.025em;
	}
	.section02 .text span {
		display: block;
	}
	.section02 .list ul {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
	}
	.section02 .list li {
		width: 33.3333%;
		padding-top: 82px;
	}
	.section02 .list li:before {
		left: 50%;
		transform: translateX(-50%);
	}
}
@media screen and (min-width: 1280px) {
	.section02 .inner-section {
		padding-top: 55px;
		padding-bottom: 63px;
	}
	.section02 .title {
		margin-bottom: 80px;
	}
	.section02 .title strong {
		margin-bottom: 30px;
		font-size: 40px;
	}
	.section02 .text {
		max-width: 860px;
		margin: 0 auto;
		font-size: 16px;
		line-height: 1.8;
	}
	.section02 .text span {
		display: inline;
	}
	.section02 .list li {
		padding-top: 158px;
		font-size: 20px;
	}
	.section02 .list li:before {
		width: 125px;
		height: 133px;
	}
}

.section03 {
	background-color: #e9e9e9;
}
.pc-web-slider {
	position: relative;
	padding-left: 15px;
	padding-right: 44px;
	padding-bottom: 52px;
}
.pc-web-slider img {
	box-shadow: 0 22.5px 30px rgba(0, 0, 0, 0.17);
}
@media screen and (min-width: 712px) {
	.section03 .inner-section {
		padding-top: 26px;
	}
	.pc-web-slider {
		padding-left: 40px;
		padding-right: 40px;
		padding-bottom: 13px;
	}
	.pc-web-slider .swiper-wrapper {
		display: block;
	}
	.pc-web-slider .swiper-wrapper li {
		float: left;
		width: calc(50% - 15px);
	}
	.pc-web-slider .swiper-wrapper li:nth-child(2n + 2) {
		float: right;
		margin-left: 30px;
	}
	.pc-web-slider .swiper-wrapper li:nth-child(n + 3) {
		margin-top: 30px;
	}
}
@media screen and (min-width: 1280px) {
	.section.full.section03 .inner-section {
		max-width: 1280px;
	}
	.section03 .inner-section {
		padding-top: 120px;
	}
	.pc-web-slider {
		padding-bottom: 122px;
		padding-left: 0;
		padding-right: 0;
	}
	.pc-web-slider .swiper-wrapper li {
		float: left;
		width: calc(50% - 12px);
	}
	.pc-web-slider .swiper-wrapper li:nth-child(2n + 2) {
		float: right;
		margin-left: 24px;
	}
	.pc-web-slider .swiper-wrapper li:nth-child(n + 3) {
		margin-top: 63px;
	}
}

.layer-project-detail > section.section04 {
	padding-bottom: 0;
}
@media screen and (min-width: 712px) {
	.section04 .inner-section {
		padding-top: 35px;
	}
}
@media screen and (min-width: 1280px) {
	.section04 .inner-section {
		max-width: none;
		padding-left: 0;
		padding-right: 0;
	}
	.section04 .project-subtit {
		max-width: 1280px;
		margin: 0 auto 77px;
	}
	.section04 .img {
		padding-right: 20px;
	}
}

.layer-project-detail > section.section05 {
	padding-bottom: 0;
}
.section05 {
	background-color: #e9e9e9;
}
@media screen and (max-width: 711px) {
	.section05 .img img {
		width: 100%;
		max-width: none;
	}
}
@media screen and (min-width: 712px) {
	.section05 .inner-section {
		padding-top: 10px;
	}
	.section05 .project-subtit {
		margin-bottom: 82px;
	}
}
@media screen and (min-width: 1280px) {
	.section05 .inner-section {
		max-width: none;
		padding-top: 60px;
		padding-left: 0;
		padding-right: 0;
	}
	.section05 .project-subtit {
		max-width: 1280px;
		margin: 0 auto 164px;
	}
	.section05 .img {
		position: relative;
		width: 100%;
		height: 1280px;
		text-align: center;
	}
	.section05 .img img {
		position: absolute;
		top: 0;
		left: 50%;
		transform: translateX(-50%);
		max-width: none;
	}
}

.section06 .inner-section {
	padding-top: 20px;
}
.font-area-wrap {
	margin-bottom: 48px;
	text-align: center;
}
.color-area-wrap .color {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	font-size: 1.2rem;
	font-weight: 500;
}
.color-area-wrap .color li {
	position: relative;
	width: 33.333%;
	padding-top: 55px;
}
.color-area-wrap .color li:before {
	content: "";
	position: absolute;
	top: 0;
	left: 5px;
	width: 45px;
	height: 45px;
	border-radius: 50%;
	background-color: #222;
}
.color-area-wrap .color .item02:before {
	background-color: #6b6b6b;
}
.color-area-wrap .color .item03:before {
	background-color: #a41d37;
}
.color-area-wrap .color .item04:before {
	background-color: #8e754a;
}
.color-area-wrap .color .item05:before {
	background-color: #a8aaad;
}
.color-area-wrap .color .item06:before {
	background-color: #eee;
}
@media screen and (max-width: 711px) {
	.font-area-wrap .img + .img {
		margin-top: 29px;
	}
	.color-area-wrap .color {
		max-width: 290px;
		margin: 0 auto;
	}
	.color-area-wrap .color li {
		margin-bottom: 25px;
	}
	.color-area-wrap .color li:nth-child(3n + 2) {
		text-align: center;
	}
	.color-area-wrap .color li:nth-child(3n + 3) {
		text-align: right;
	}
	.color-area-wrap .color li:nth-child(3n + 2):before {
		left: calc(50% - 22.5px);
	}
	.color-area-wrap .color li:nth-child(3n + 3):before {
		right: 2px;
		left: auto;
	}
}
@media screen and (min-width: 712px) {
	.section06 .inner-section {
		padding-top: 50px;
		padding-bottom: 20px;
	}
	.font-area-wrap .img {
		float: left;
		width: calc(50% - 37px);
		margin-top: 5px;
	}
	.font-area-wrap .img + .img {
		margin-left: 74px;
		margin-top: 0;
	}
	.color-area-wrap .color li {
		width: 55px;
		text-align: center;
	}
	.color-area-wrap .color li:before {
		left: calc(50% - 22.5px);
	}
}
@media screen and (min-width: 1280px) {
	.section06 .inner-section {
		padding: 118px 20px 110px;
	}
	.font-area-wrap {
		margin-bottom: 95px;
	}
	.font-area-wrap .img {
		float: left;
		width: calc(50% - 52px);
		margin-top: 8px;
	}
	.font-area-wrap .img + .img {
		margin-left: 104px;
		margin-top: 0;
	}
	.color-area-wrap .color li {
		width: 100px;
		padding-top: 100px;
		text-align: center;
	}
	.color-area-wrap .color li:before {
		left: calc(50% - 45px);
		width: 90px;
		height: 90px;
	}
}
</style>



// WEBPACK FOOTER //
// src/projects/lgchem.vue